import React from "react";

const logos = {
  "Artline": <img alt="Artline" src={require('./artline.png')} />,
  "Artline Supreme": <img alt="Artline Supreme" src={require('./artline-supreme.png')} />,
  "Bic": <img alt="Bic" src={require('./bic.png')} />,
  "Caran D'ache": <img alt="Caran D'ache" src={require('./caran-dache.png')} />,
  "Colourhide": <img alt="Colourhide" src={require('./colourhide.png')} />,
  "Crayola": <img alt="Crayola" src={require('./crayola.png')} />,
  "Crayola Signature": <img alt="Crayola Signature" src={require('./crayola-signature.png')} />,
  // "Emott": <img alt="Emott" src={require('./emott.png')} />,
  "Expo": <img alt="Expo" src={require('./expo.png')} />,
  "Faber-Castell": <img alt="Faber Castell" src={require('./faber-castell.png')} />,
  "Giotto": <img alt="Giotto" src={require('./giotto.png')} />,
  // "Inkjoy": <img alt="Inkjoy" src={require('./inkjoy.png')} />,
  "Ironlak": <img alt="Ironlak" src={require('./ironlak.png')} />,
  "J.Burrows": <img alt="J.Burrows" src={require('./j-burrows.png')} />,
  "Kaweco": <img alt="Kaweco" src={require('./kaweco.png')} />,
  "Keji": <img alt="Keji" src={require('./keji.png')} />,
  "Lamy": <img alt="Lamy" src={require('./lamy.png')} />,
  "Maped": <img alt="Maped" src={require('./maped.png')} />,
  "Micador for Artist": <img alt="Micador" src={require('./micador.png')} />,
  "Milan": <img alt="Milan" src={require('./milan.png')} />,
  "Online": <img alt="Online" src={require('./online-germany.png')} />,
  "Otto": <img alt="Otto" src={require('./otto-hutt.png')} />,
  "Papermate": <img alt="Papermate" src={require('./papermate.png')} />,
  // "Papermate Inkjoy": <img alt="Papermate Inkjoy" src={require('./papermate-inkjoy.png')} />,
  "Parker": <img alt="Parker" src={require('./parker.png')} />,
  "Pentel": <img alt="Pentel" src={require('./pentel.png')} />,
  "Pilot": <img alt="Pilot" src={require('./pilot.png')} />,
  "Posca": <img alt="Posca" src={require('./posca.png')} />,
  "Prismacolor": <img alt="Prismacolor" src={require('./prismacolor.png')} />,
  "Sharpie": <img alt="Sharpie" src={require('./sharpie.png')} />,
  "Sheaffer": <img alt="Sheaffer" src={require('./sheaffer.png')} />,
  "Stabilo": <img alt="Stabilo" src={require('./stabilo.png')} />,
  "Staedtler": <img alt="Staedtler" src={require('./staedtler.png')} />,
  "Studymate": <img alt="Studymate" src={require('./studymate.png')} />,
  "Texta": <img alt="Texta" src={require('./texta.png')} />,
  "UNI": <img alt="UNI" src={require('./uni-mitsubishi-pencil.png')} />,
  "Uniball": <img alt="Uniball" src={require('./uniball.png')} />,
  "Winsor And Newton": <img alt="Winsor And Newton" src={require('./winsor-newton.png')} />,
  "Zebra": <img alt="Zebra" src={require('./zebra.png')} />,
  
}

export default logos;